"use client";

import { useTranslations } from "@zapier/i18n";
import { Text } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";
import { useSplitTreatments } from "@zapier/client";
import { usePathname } from "next/navigation";
import Link from "next/link";
import classNames from "classnames";

import { useEmitTrashNavClickEvent } from "../../../events/useEmitTrashNavClickEvent";
import { TRASH_HREF } from "./trashHref";
import styles from "./TrashLink.module.css";

export function TrashLink() {
  const t = useTranslations("asset-layout");
  const { isZapAndCanvasUnifiedTrashEnabled } = useSplitTreatments();
  const pathname = usePathname();
  const { emit: emitTrashNavClick } = useEmitTrashNavClickEvent();

  if (!isZapAndCanvasUnifiedTrashEnabled) {
    return null;
  }

  const isTrashPage = pathname?.startsWith(TRASH_HREF) ?? false;

  return (
    // DS gap: BetaSecondaryNavItem has no supported selected-state API, so
    // this bridges with first-party markup/CSS instead (see FolderTreeItem).
    <nav
      className={styles.trashNav}
      aria-label={t("navigation.trash-nav-label")}
      data-custom-component="assetmanagement::trash-sidebar-link"
    >
      <Link
        href={TRASH_HREF}
        onClick={() => emitTrashNavClick("sidebar")}
        aria-current={isTrashPage ? "page" : undefined}
        className={classNames(styles.trashLink, {
          [styles.trashLinkSelected]: isTrashPage,
        })}
      >
        <Icon
          name="actionTrash"
          size={20}
          color={isTrashPage ? "BrandOrange" : "GrayWarm6"}
          aria-hidden={true}
        />
        <Text type="Body1" color="TextDefault" className={styles.trashLinkText}>
          {t("navigation.trash")}
        </Text>
      </Link>
    </nav>
  );
}
